
angular.module('trainerWebApp.services').factory('manageUsersSearch', ['userGridUtils', 'trackingService', function (userGridUtils, trackingService) {

  function createSearchSettings(params) {
    function createGetData(data) {
      return function () {
        return data;
      }
    }

    var ungroupedText="Ungrouped users";

    function createUngroupedUsersItem(){
      return {
        id:"ungroupedusers|ungroupedusers",
        label:null,
        cssClass:'match-italic',
        text:ungroupedText,
        field:groupField,
        dataForFilter:-1,
        track:groupField.track
      };
    }

    function formatGroupResults(results, term, isSecondLevelMenu) {
      if (mfConfig.useGroupRestrictions) {
        return results;
      }

      if (results.length == 1 && results[0].children) {
        results[0].children.push(createUngroupedUsersItem());
      }
      else if (results.length > 0 || (term && ungroupedText.toLowerCase().indexOf(term.toLowerCase()) == 0))
      {
        if (isSecondLevelMenu)
          results.unshift(createUngroupedUsersItem());
        else
          results.push(createUngroupedUsersItem());
      }
      return results;
    }

    function fieldFilter(name) {
      return function (term) {
        return userGridUtils.filter.createFilter(userGridUtils.filter.byFields, [term, [name]]);
      }
    }

    var fieldTrackingMap = {
      allfields: trackingService.pages.usersManage.actions.searchByAllFields,
      name: trackingService.pages.usersManage.actions.searchByName,
      email: trackingService.pages.usersManage.actions.searchByEmail,
      course:trackingService.pages.usersManage.actions.searchByCourse,
      series: trackingService.pages.usersManage.actions.searchBySeries,
      group: trackingService.pages.usersManage.actions.searchByGroup,
      ungrouped: trackingService.pages.usersManage.actions.searchForUngrouped,
      customField: trackingService.pages.usersManage.actions.searchByCustomField,
      username: trackingService.pages.usersManage.actions.searchByUsername
    };

    function fieldTracking(name) {
      return function () {
        if(fieldTrackingMap[name])
          trackingService.trackEvent(trackingService.pages.usersManage.name, fieldTrackingMap[name]);
      }
    }

    var groupField = {name:'group', label:'Group', shortcut:"group", groupLabel:"Groups:", groupName:"groupGroup",
      getSuggestions:createGetData(params.groups),
      formatResults:formatGroupResults,
      createFilterAsync:function (id, cb) {
        var filter = userGridUtils.filter.createFilter(
          userGridUtils.filter.byGroupMembership,
          [id]);
        cb(filter);
      },
      track:fieldTracking('group')};

    var fields = [
      {name:'allfields', label:null, shortcut:'allfields',
        createFilterSync:function (term) {
          return userGridUtils.filter.createFilter(userGridUtils.filter.byAllTextFields, term)
        },
        track:fieldTracking('allfields')},
      {name:'name', label:'Name', shortcut:"name",
        createFilterSync:function (term) {
          return userGridUtils.filter.createFilter(userGridUtils.filter.byPersonName, [term])
        },
        track:fieldTracking('name')},
      {name:'email', label:'Email', shortcut:"email", createFilterSync:fieldFilter('email'), track:fieldTracking('email')},
      {name:'username', label:'Username', shortcut:"username", createFilterSync:fieldFilter('username'), track:fieldTracking('username')},
      {name:'course', label:'Course', shortcut:"course", groupLabel:"Courses:", groupName:"courseGroup",
        getSuggestions:createGetData(params.courses),
        createFilterAsync:function (id, cb) {
          params.loadCourseStates(id, function (courseStates) {
            var filter = userGridUtils.filter.createFilter(
              userGridUtils.filter.byCourseState,
              [courseStates]);
            cb(filter);
          });
        },
        track:fieldTracking('course')},
      {name:'series', label:'Series', shortcut:"series", groupLabel:"Series:", groupName:"seriesGroup",
        getSuggestions:createGetData(params.series),
        createFilterAsync:function (id, cb) {
          params.loadSeriesStates(id, function (seriesStates) {
            var filter = userGridUtils.filter.createFilter(
              userGridUtils.filter.bySeriesState,
              [seriesStates]);
            cb(filter);
          });
        },
        track:fieldTracking('series')},
      groupField
    ];

    if (params.customFields) {
      for (var i = 0; i < params.customFields.length; i++) {
        if (params.customFields[i])
          fields.push({
            name:'customField' + params.customFields[i].displayOrder,
            label:params.customFields[i].name, shortcut:params.customFields[i].name.toLowerCase(),
            createFilterSync:fieldFilter('customField' + params.customFields[i].displayOrder),
            track:fieldTracking('customField')});
      }
    }

    return {
      fields:fields,
      setFilter:params.setFilter,
      filterHasResults:params.filterHasResults,
      gaPageName:params.gaPageName,
      notifySearchChanged:params.notifySearchChanged
    }
  }

  return {
    createSearchSettings:createSearchSettings
  }
}]);
